module.exports = "//docs.gtimg.com/slide/img/page/toc/common/meeting-room-manager/img/svg/doc_logo-73a677.svg";